import { ComponentNameEnum, DropdownOption } from '@/types';

const getDropdownFieldConfig = (
  options: DropdownOption[] | Promise<DropdownOption[]> = [],
  defaultValue = '',
  filter = false,
) => ({
  componentName: ComponentNameEnum.DROPDOWN,
  options: {
    list: options,
    defaultValue,
    filter,
  },
});

export default getDropdownFieldConfig;
